<template>
  <RenderEvent
    :key="routeKey"
    :event="this.$route.params.subPage || 'page'"
    :only="this.$route.params.id"
  />
</template>

<script>
import RenderEvent from "../../components/integrations/RenderEvent.vue";

export default {
  components: {
    RenderEvent,
  },
  computed: {
    routeKey() {
      return `${this.$route.params.id}-${this.$route.params.subPage || 'page'}`
    }
  }
};
</script>
